// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCuMECIXi5ATDe4iFl0qddWBtEvLY_X974",
  authDomain: "etcmc-dao-voting-app.firebaseapp.com",
  projectId: "etcmc-dao-voting-app",
  storageBucket: "etcmc-dao-voting-app.appspot.com",
  messagingSenderId: "553364426502",
  appId: "1:553364426502:web:862dee388268a77106d887",
  measurementId: "G-WM7X10CMV3"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };



